import { render, staticRenderFns } from "./modal-base.vue?vue&type=template&id=4535f32e&"
import script from "./modal-base.vue?vue&type=script&lang=js&"
export * from "./modal-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports